import { GridItemParams } from './GridItem.props';
import { WraperItem } from './styles';

export const GridItem = ({ children, ...props }: GridItemParams) => {
    return <WraperItem {...props}>{children}</WraperItem>;
};
